import PropTypes from 'prop-types'
import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import UnderlineHeading from '../UnderlineText/UnderlineHeading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function FileDownloader({ linkToFile, downloadText, icon }) {
  const { texts } = useLabels()
  return (
    <Flex
      direction="column"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <UnderlineHeading variant="h5" text={texts.download_excel_template} />
      <Box mt="60px" w="328px" h="96px">
        <Button
          w="328px"
          h="96px"
          as={Link}
          to={linkToFile || ''}
          target="_blank"
          variant="white"
          download
          p="25px 29px"
        >
          <HStack>
            {icon && <FontAwesomeIcon icon={icon} />}
            <Text variant={'h5'}>
              {downloadText || texts.download_excel_file}
            </Text>
          </HStack>
        </Button>
      </Box>
    </Flex>
  )
}

FileDownloader.propTypes = {
  downloadText: PropTypes.string,
  icon: PropTypes.any,
  linkToFile: PropTypes.string,
}
